import { createStyle } from '@gluestack-style/react';

export const FormControlLabelText = createStyle({
  fontWeight: '$medium',
  color: '$textLight900',
  _dark: {
    color: '$textDark50',
  },
});
